import { render, staticRenderFns } from "./ImportFileButton.vue?vue&type=template&id=5ca0c5cf&scoped=true"
import script from "./ImportFileButton.vue?vue&type=script&lang=js"
export * from "./ImportFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0c5cf",
  null
  
)

export default component.exports